import React from "react";
import {
    Route,
    NavLink,
    HashRouter
} from "react-router-dom";
import Home from "./Home";
import Information from "./Information";
import Results from "./Results";
import { loc } from "./Helpers/Localizations";

function Main() {
    return (
        <HashRouter>
          <div className="main-page">
            <nav class="flex items-center flex-wrap bg-gray-900 p-4">
                <div class="flex items-center flex-shrink-0 text-white mr-6">
                    <li class="flex items-center px-3 py-2 rounded text-teal-200 hover:text-white"><NavLink to="/">{loc('Home')}</NavLink></li>
                </div>
                <div class="flex items-center flex-shrink-0 text-white mr-6">
                    <li class="flex items-center px-3 py-2 rounded text-teal-200 hover:text-white"><NavLink to="/results">{loc('Results')}</NavLink></li>
                </div>
                <div class="flex items-center flex-shrink-0 text-white mr-6">
                    <li class="flex items-center px-3 py-2 rounded text-teal-200 hover:text-white"><NavLink to="/information">{loc('Information')}</NavLink></li>
                </div>
            </nav>
            <div className="content" class="h-screen">
                <Route exact path="/" component={Home}/>
                <Route path="/results" component={Results}/>
                <Route path="/information" component={Information}/>
            </div>
          </div>
        </HashRouter>
      );
  }
   
  export default Main;